import CryptoJS, { enc } from 'crypto-js';
import { key_main } from '../constants/system.keys';

export function encrypt(data) {
  const keyHex = CryptoJS.enc.Utf8.parse(key_main.slice(16));
  const encrypted = CryptoJS.AES.encrypt(data, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

export function decrypt(encrypted) {
  const keyHex = CryptoJS.enc.Utf8.parse(key_main.slice(16));
  const decrypted = CryptoJS.AES.decrypt(encrypted, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

export function encryptDynamic(data, key) {
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  const encrypted = CryptoJS.AES.encrypt(data, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

export function decryptDynamic(encrypted, key) {
  try {
    const keyHex = CryptoJS.enc.Utf8.parse(key);
    const decrypted = CryptoJS.AES.decrypt(encrypted, keyHex, {
      mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Decrypt failed', error);
    return encrypted;
  }
}
